import {
    getOptionsForFeature,
    OwsOptionsFeatureType,
    TranslationOptions,
} from 'owa-outlook-service-options';
import { mutatorAction } from 'satcheljs';
import { lazyUpdateTranslationOptions } from 'owa-translation';

export default mutatorAction('addExcludedLanguage', function addExcludedLanguage(language: string) {
    const userOptions = getOptionsForFeature<TranslationOptions>(OwsOptionsFeatureType.Translation);

    // Need to track the original options to log differences
    const originalOptions: TranslationOptions = {
        feature: userOptions.feature,
        translationMode: userOptions.translationMode,
        excludedLanguages: [...userOptions.excludedLanguages],
    };

    userOptions.excludedLanguages.push(language);

    lazyUpdateTranslationOptions.import().then(updateTranslationOptions => {
        updateTranslationOptions(originalOptions, userOptions);
    });
});
